import { uiActions } from "../action-types";

export const uiChangeCollapsedState = (): uiActions.IUIChangeCollapsedState =>({
    type: uiActions.UI_CHANGE_COLLAPSED_STATE
})